import { signedDraftBody } from './signatureModel';
import axios from 'axios';
import { API_DOMAIN } from '../constants';

export async function mailRequest(path, options = {}) {
  const response = await axios({ url: `${API_DOMAIN}/mailbox${path}`, method: 'get', ...options, headers: { accessToken: localStorage.getItem('accessToken') } });
  if (options.responseType === 'blob') return response.data;
  if (!response.data?.success) throw new Error(response.data?.message || 'Unable to load mail.');
  return response.data.data;
}
export const mailError = error => error?.response?.data?.message || error?.message || 'Mailbox unavailable. Please try again.';
export const draftKey = (userId, email) => `srm:mail:draft:v1:${userId}:${String(email).toLowerCase()}`;
export const emptyDraft = () => ({ mode: 'compose', to: '', cc: '', bcc: '', subject: '', text_body: '', attachments: [], minimized: false, command: null });
export function saveLocalDraft(key, draft, storage = localStorage) {
  storage.setItem(key, JSON.stringify({ ...draft, attachments: (draft.attachments || []).map(({ filename, mime_type, size_bytes }) => ({ filename, mime_type, size_bytes, needs_reattach: true })) }));
}
export function loadLocalDraft(key, storage = localStorage) {
  const value = storage.getItem(key);
  if (!value) return null;
  const draft = JSON.parse(value);
  if (!draft || typeof draft.text_body !== 'string' || !Array.isArray(draft.attachments)) throw new Error('The saved draft could not be read.');
  return { ...emptyDraft(), ...draft, attachments: draft.attachments.map(file => ({ ...file, needs_reattach: true })), command: draft.command?.status === 'sending' ? { ...draft.command, status: 'uncertain' } : draft.command };
}
export function commandIsUncertain(error) {
  const status = error?.response?.status;
  return !status || status >= 500 || status === 408 || ['MAIL_COMMAND_OUTCOME_UNCERTAIN', 'MAIL_COMMAND_IN_PROGRESS', 'IDEMPOTENCY_KEY_REUSED'].includes(error?.response?.data?.data?.code);
}
export function sendPayload(draft, key) {
  const common = { ...signedDraftBody(draft), attachments: draft.attachments.map(({ filename, mime_type, content_base64 }) => ({ filename, mime_type, content_base64 })), idempotency_key: key };
  if (draft.mode === 'reply') return { ...common, reply_all: !!draft.reply_all };
  if (draft.mode === 'gmail-draft') return { idempotency_key: key };
  return { ...common, to: draft.to, cc: draft.cc, bcc: draft.bcc, subject: draft.subject };
}
export function sendPath(draft) {
  if (draft.mode === 'gmail-draft') return `/drafts/${encodeURIComponent(draft.draft_id)}/send`;
  if (draft.mode === 'reply' || draft.mode === 'forward') return `/threads/${encodeURIComponent(draft.thread_id)}/${draft.mode}`;
  return '/messages/send';
}
export const readableMailDate = value => value && !Number.isNaN(Date.parse(value)) ? new Date(value).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '';

export { emailDocument } from './emailRendering';

// Compare local calendar dates, matching the timezone used to display the time.
export const readableMailListDate = (value, now = new Date()) => {
  if (!value || Number.isNaN(Date.parse(value))) return '';
  const date = new Date(value);
  return date.toDateString() === now.toDateString()
    ? date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
    : readableMailDate(value);
};
